import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { DEFAULT_VEHICLE_CATEGORY_QUERY_PARAMS } from "../api";
import { CertificateVehicleCategory, CertificateVehicleCategoryFilterPageRequest } from "../types";
import { VehicleCategoryFilterForm } from "./forms/VehicleCategoryFilterForm";
import { VehicleCategoryForm } from "./forms/VehicleCategoryForm";
import { VehicleCategoryTable } from "./tables/VehicleCategoryTable";

export const VehicleCategoryTabView = () => {
  const [categoryFormOpen, setCategoryFormOpen] = useState<boolean>(false);
  const [categoryToUpdate, setCategoryToUpdate] = useState<CertificateVehicleCategory>();

  const searchParams = useFilterSearchParams<CertificateVehicleCategoryFilterPageRequest>({
    params: ["categories"],
    defaultQueryParamsObject: DEFAULT_VEHICLE_CATEGORY_QUERY_PARAMS,
  });

  const handleCreateClick = () => {
    setCategoryFormOpen(true);
  };

  const handleUpdateClick = (category: CertificateVehicleCategory) => {
    setCategoryFormOpen(true);
    setCategoryToUpdate(category);
  };

  const handleFormCancel = () => {
    setCategoryFormOpen(false);
    setCategoryToUpdate(undefined);
  };

  return (
    <div>
      <VehicleCategoryFilterForm searchParams={searchParams} onCreateClick={handleCreateClick} />

      <VehicleCategoryTable searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <VehicleCategoryForm category={categoryToUpdate} open={categoryFormOpen} onFormCancel={handleFormCancel} />
    </div>
  );
};
